import { createContext } from "react"

import { Client } from "api/client"

interface ClientContextState {
  client: Client | undefined
  setClient: (client: Client) => void
  isTealiumReady: boolean
}

const initialValue: ClientContextState = {
  client: undefined,
  setClient: () => {},
  isTealiumReady: false
}

export const ClientContext = createContext(initialValue)
